import React, { FC, PropsWithChildren } from 'react';

import { AbgTypography } from '@abg/kit-base';

import * as styles from './EmptyState.styling';

const EMPTY_STATE = '-';

export const EmptyState: FC<PropsWithChildren> = ({ children }) => (
  <AbgTypography sx={styles.typographyEmptyState} data-testid="empty-state">
    {children ?? EMPTY_STATE}
  </AbgTypography>
);
